// import ReactGA from 'react-ga';

const ga = {
  sendEventsToGA: () => {
    // saved for later
    // if (config.APP_ENV === 'production') {
    //   // Old GA for Grab & julo starts
    //   if (utils.store.get('phoneNumberGA') !== '') {
    //     ReactGA.initialize(config.gaIdGrab, {
    //       gaOptions: {
    //         userId: utils.store.get('phoneNumberGA'),
    //       },
    //     });
    //     ReactGA.ga('create', config.GA4_JULO, 'auto', {
    //       name: 'trackerName',
    //       userId: utils.store.get('phoneNumberGA'),
    //     });
    //   } else {
    //     ReactGA.initialize(config.gaIdGrab);
    //     ReactGA.ga('create', config.GA4_JULO, 'auto', { name: 'trackerName' });
    //   }
    //   ReactGA.event({
    //     category: eventCategory,
    //     action: eventAction,
    //     label: eventLabel,
    //   });
    //   ReactGA.ga('trackerName.send', 'event', {
    //     eventCategory: eventCategory,
    //     eventAction: eventAction,
    //     eventLabel: eventLabel,
    //   });
    //   // Old GA for Grab & julo ends
    // } else {
    //   // Old GA for julo starts
    //   if (utils.store.get('phoneNumberGA') !== '') {
    //     ReactGA.initialize(config.GA4_JULO, {
    //       gaOptions: {
    //         userId: utils.store.get('phoneNumberGA'),
    //       },
    //     });
    //   } else {
    //     ReactGA.initialize(config.GA4_JULO);
    //   }
    //   ReactGA.event({
    //     category: eventCategory,
    //     action: eventAction,
    //     label: eventLabel,
    //   });
    //   // Old GA for julo ends
    // }
  },
};

export default ga;
